import {checkNumber} from "./check-number";

export const min = (min) => ({
    name: "min",
    min,
    validate: checkNumber((v) => v >= min),
});
